import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=0bea6ddc"
import script from "./CookieBar.vue?vue&type=script&lang=ts"
export * from "./CookieBar.vue?vue&type=script&lang=ts"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=0bea6ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports